import { useTranslation } from 'react-i18next'
import { Button, Flex, Result } from 'antd'
import { Link } from '@tanstack/react-router'
import React from 'react'

type NotSubscribedResultProps = {
    /** Off on a campaign's own page: the customer just made one, and only needs the plan now. */
    withCreateCampaign?: boolean
}

export function NotSubscribedResult({ withCreateCampaign = true }: NotSubscribedResultProps) {
    const { t } = useTranslation()

    return (
        <Result
            className="w-full"
            icon={<span className="-mt-6 block"></span>}
            title={t('You don’t have a plan yet')}
            subTitle={t('Choose a plan to use Evaa on WhatsApp or on your website.')}
            extra={
                <Flex
                    className="w-full"
                    justify="center"
                    align="center"
                    gap="small"
                >
                    <Link to="/settings">
                        <Button
                            size="large"
                            type="primary"
                        >
                            {t('Subscribe')}
                        </Button>
                    </Link>
                    {withCreateCampaign && (
                        <Link to="/campaigns/create">
                            <Button size="large">{t('Create {{name}}', { name: t('Campaign') })}</Button>
                        </Link>
                    )}
                </Flex>
            }
        />
    )
}
